/**
 * @module geo/types/services
 */

/**
 * @hidden
 * @private
 */
export enum KindService {
  GET_IMAGE_MAP = 'GET_IMAGE_MAP',
  CALL_METHOD = 'CALL_METHOD',
  CALL_REST = 'CALL_REST',
  FEATURE_TRANSACTION = 'FEATURE_TRANSACTION',
  EXECUTE_SEARCH = 'EXECUTE_SEARCH',
  OTHER_SERVICE = '__any_other_service_type__'
}
